export default class LockTableMouseEventsHandlerState {
    constructor(mouseEventsHandler) {
        this.mouseEventsHandler = mouseEventsHandler;
    }

    mouseDown(evt, cell) {}

    mouseUp(evt, cell) {}

    mouseMove(evt, cell) {}

    mouseOver(evt, cell) {
        this.lastHoveredCell = cell;
    }

    mouseOut(evt, cell) {
        this.lastHoveredCell = null;
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/LockTableMouseEventsHandlerState.js